__turbopack_context__.v({
  "default": "DiscoveryButton-module__ZDk7kq__default",
  "disabled": "DiscoveryButton-module__ZDk7kq__disabled",
  "icon": "DiscoveryButton-module__ZDk7kq__icon",
  "label": "DiscoveryButton-module__ZDk7kq__label",
  "link": "DiscoveryButton-module__ZDk7kq__link",
  "root": "DiscoveryButton-module__ZDk7kq__root",
  "secondary": "DiscoveryButton-module__ZDk7kq__secondary",
});
